<template>
<div class="chapter">
<div class="inner_page">
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Kime_9781440501951_epub_cov.vue?4e6da654